import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import TileButton from 'components/atoms/TileButton';
import SimulationList, {
    commonClassName,
    commonHeaderClass,
} from 'components/organism/PriceSimulator/SimulationList/SimulationList';
import Comparison from 'components/organism/PriceSimulator/Comparison/Comparison';
import { FilterContextData } from 'contexts/FilterContext';
import { useFetchAllScenarios } from 'hooks/priceSimulator';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PSR_GLOBAL_TILE_CHANGED } from 'utils/mixpanelEventNames';

const simulationTileData = [
    { key: 'simulation', label: 'Simulation', header: 'Pricing Simulator' },
    { key: 'comparison', label: 'Comparison', header: 'Scenario Comparison' },
];

const PriceSimulator = () => {
    const [simulationTile, setSimulationTile] = useState(simulationTileData[0]);
    const { allDimAndAttributeTypeList } = useContext(FilterContextData);
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
    const [allScenariosDataSet, setAllScenariosDataSet] = useState<any>([]);
    const { appConfig } = useContext(UserContext);
    const { allScenariosTableLimit } = getConfig('priceSimulator', appConfig);

    //fetch all scenarios GQL
    const {
        loading: allScenariosLoading,
        data: allScenariosData,
        error: allScenariosError,
        fetchAllScenarios,
    } = useFetchAllScenarios();

    useEffect(() => {
        setAllScenariosDataSet(allScenariosData);
    }, [allScenariosData]);

    useEffect(() => {
        if (
            allDimAndAttributeTypeList &&
            'loading' in allDimAndAttributeTypeList &&
            !allDimAndAttributeTypeList['loading'] &&
            allDimAndAttributeTypeList['dimentions']
        ) {
            fetchAllScenarios({
                variables: {
                    limit: allScenariosTableLimit,
                    offset: 0,
                },
            });
        }
    }, [allDimAndAttributeTypeList?.loading]);

    const commonLoading = allDimAndAttributeTypeList?.loading || allScenariosLoading;

    return (
        <section
            className={` ${commonClassName} bg-white h-full relative`}
            // style={{ minHeight: 'calc(100vh - 100px)' }}
            id="price-simulator-page"
        >
            <div className="flex justify-between items-center">
                <div className="flex gap-4 items-center">
                    <h2 className={commonHeaderClass}>{simulationTile.header}</h2>
                    <TileButton
                        disabled={commonLoading}
                        data={simulationTileData}
                        activeKey={simulationTile.key}
                        onClick={(item: any) => {
                            setSimulationTile(item);
                            trackEventMixpanel(PSR_GLOBAL_TILE_CHANGED, {
                                tileName: item.label,
                            });
                        }}
                    />
                </div>
            </div>
            {simulationTile.key === simulationTileData[0].key ? (
                <SimulationList
                    setSimulationTile={setSimulationTile}
                    simulationTileData={simulationTileData}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                    allScenariosDataSet={allScenariosDataSet}
                    setAllScenariosDataSet={setAllScenariosDataSet}
                    allScenariosLoading={allScenariosLoading}
                />
            ) : (
                <Comparison
                    setSelectedRowKeys={setSelectedRowKeys}
                    selectedRowKeys={selectedRowKeys}
                    allScenariosInfo={allScenariosDataSet?.map((item: any) => {
                        return {
                            name: item.Scenario,
                            scenarioId: item.scenarioId,
                            dataSourceType: item['Data Source'],
                        };
                    })}
                />
            )}
        </section>
    );
};

export default PriceSimulator;
